

























































import { Component, Vue } from 'vue-property-decorator'
import { Mutation, Action } from 'vuex-class'
import { mapState } from 'vuex'
import _PaymentIQ1Click from 'paymentiq-1click-client'

declare global {
  interface Window {
    _PaymentIQ1Click: any
  }
}

@Component({
  computed: {
    ...mapState({
      fullName: ({ gamblingContext }: any): null | string => gamblingContext.credentials.username,
      email: ({ gamblingContext }: any): null | string => gamblingContext.credentials.email,
      pageLayout: ({ gamblingContext }: any) => gamblingContext.pageLayout,
      logInModal: ({ gamblingContext }: any) => gamblingContext.logInModal,
      loginMethods: ({ gamblingContext }: any) => gamblingContext.loginMethods,
      loginMethodState: ({ gamblingContext }: any) => gamblingContext.loginMethod
    })
  }
})

export default class LoginContent extends Vue {
  @Action('loginUser') loginUser: any
  @Action('fetchUserKYC') fetchUserKYC: any
  @Mutation('setLoginMethod') setLoginMethod: any
  @Mutation('setLogInModal') setLogInModal: any
  @Mutation('setEmail') setEmail: any
  @Mutation('setUsername') setUsername: any

  private loginMethods!: object[]
  private loginMethodState!: string
  private fullName!: null | string
  private email!: null | string
  private logInSuccess: boolean = false
  private showSpinner: boolean = false
  private loginContainerId!: string
  private logInModal!: boolean
  private $smallScreen!: boolean

  get getLoginMethods () {
    return this.loginMethods.map((val: any) => val.label).sort()
  }

  get loaderColor () {
    const staticColor = this.$route.path.includes('/gambling/account') ? 'white--text' : 'secondary--text'
    return staticColor
  }

  get loginMethod () {
    return this.loginMethodState
  }
  set loginMethod (val: string) {
    this.setLoginMethod(val)
  }

  get getEmail (): null | string {
    return this.email
  }
  set getEmail (val: null | string) {
    this.setEmail(val)
  }
  get getUserName (): null | string {
    return this.fullName
  }
  set getUserName (val: null | string) {
    this.setUsername(val)
  }

  destroyGiiClient () {
    const myElement: HTMLElement | null =  document.getElementById(this.loginContainerId)
    if (myElement) {
      myElement.innerHTML = ''
    }
  }

  setupGiiClient (method: string) {
    const { providerName }: any = this.loginMethods.find((val: any) => val.label === method)
    let clientId = '9c2da13a819b4d6bad90aa51c8131249' // simon demo
    const prodProviders = ['gii-bankid', 'trustly', 'zimpler', 'paypal']
    if (prodProviders.includes(providerName)) {
      clientId = '6a864898a12c42fd974eaae1c2a86443' // jun test prod
    }
    if (this.$refs[this.loginContainerId]) {
      this.destroyGiiClient()
      try {
        new _PaymentIQ1Click(`#${this.loginContainerId}`, {
          environment: 'test',
          clientId,
          country: 'SE',
          provider: providerName,
          authCookieName: 'JSESSIONID',
          display: 'inline-popup'
        },
          (oneClick: any) => {
            this.showSpinner = false
            oneClick.on({
              complete: (data: any) => {
                console.log('SUCCESSFUL LOGIN - now checking user kyc')
                this.fetchUserKYC({ data, basicAuth: 'Basic NmE4NjQ4OThhMTJjNDJmZDk3NGVhYWUxYzJhODY0NDM6YTQ4Y2NjMWRjYmZlNGFhOWFmMGQ4MDlhMjg0MTJiY2M=' })
              },
              failure: (data: any) => console.log('Failed login', data)
            })
          }
        )
      } catch (err) {
        console.log(err)
      }
    }
  }

  changeLoginMethod (method: string): void {
    this.loginMethod = method
    this.setLoginMethod(method)
    if (this.loginMethod !== 'Email') {
      this.$nextTick(() => {
        this.setupGiiClient(method)
      })
    } else {
      this.destroyGiiClient()
    }
  }

  created () {
    if (this.logInModal) {
      this.loginContainerId = 'gii-login-container-modal'
    } else {
      this.loginContainerId = 'gii-login-container'
    }
    this.changeLoginMethod('Email')
    this.showSpinner = true
  }
}
